// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4y-1";
export var standaloneTable = "_4y-0";